import { Divider, Grid } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import StickyHeadTable from "ui-components/tables/StickyTable";
import Drawer from "ui-components/Drawer";
import MDBadge from "components/MDBadge";
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";
import { getPickslipPackLog } from "services/data.outbound.service";

function PickslipPackScanLog({ open, setOpen, logRequest, setLogRequest }) {
  const columns = [
    { label: "Box Id", id: "boxId" },
    { label: "Package Id", id: "packageId" },
    { label: "SKU Code", id: "skuCode" },
    { label: "Quantity", id: "quantity" },
    { label: "Box Type", id: "boxType" },
    { label: "Status", id: "status" },
    //{ label: "Created On", id: "createdOn" },
    //{ label: "Updated On", id: "updatedOn" }
  ];
  const { data } = useQuery({
    queryKey: ["pickslip-pick-log", { logRequest }],
    queryFn: () => getPickslipPackLog(logRequest),
    enabled: Boolean(logRequest),
  });

  const details = data?.data.data.details.map((d) => ({
    ...d,
    status:
      d.status === "A" ? (
        <MDBadge variant="gradient" color="warning" size="xs" badgeContent="Scanning" container />
      ) : (
        <MDBadge variant="gradient" color="success" size="xs" badgeContent="Complete" container />
      ),
  }));

  const toggleDrawer = (open) => (event) => {
    if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
      return;
    }
    setOpen(open);
    setLogRequest(null);
  };

  return (
    <Drawer width="1400px" open={open} onClose={toggleDrawer(false)} onOpen={toggleDrawer(true)}>
      <MDTypography variant="h5" color="info">
        Pickslip Pack Scan
      </MDTypography>
      <Divider sx={{ margin: "5px 0", background: "#9ebeeb", opacity: "unset" }} />
      {Boolean(data) && (
        <>
          <MDBox style={{ fontSize: "14px", marginBottom: "20px" }}>
             
            <Grid container>
              <Grid item xs={6}>
                <b>Pickslip Number : </b>
                {logRequest.pickslipNumber}
              </Grid>
            </Grid>
          </MDBox>
          <StickyHeadTable columns={columns} rows={details} />
        </>
      )}
    </Drawer>
  );
}

export default PickslipPackScanLog;
